import { render, staticRenderFns } from "./DangerSettings.vue?vue&type=template&id=612dc653&"
import script from "./DangerSettings.vue?vue&type=script&lang=js&"
export * from "./DangerSettings.vue?vue&type=script&lang=js&"
import style0 from "./DangerSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports